"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _AppTheme = _interopRequireDefault(require("../../../../AppTheme"));

var _ButtonIcon = _interopRequireDefault(require("../../../atoms/buttons/buttonIcon/ButtonIcon"));

var _Typography = _interopRequireDefault(require("../../../protons/typography/Typography"));

var _BoxFlex = _interopRequireDefault(require("../../../layouts/box/boxFlex/BoxFlex"));

var _BoxSizing = _interopRequireDefault(require("../../../layouts/box/boxSizing/BoxSizing"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      width: '610px',
      borderRadius: '6px',
      backgroundColor: theme.palette.common.white,
      boxShadow: "0 2px 8px ".concat((0, _styles.fade)(theme.palette.common.black, 0.16))
    },
    dialogChildren: {
      overflow: 'hidden'
    }
  };
});

var Transition = /*#__PURE__*/_react.default.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_react.default.createElement(_core.Slide, _extends({
    direction: "up",
    ref: ref
  }, props));
});

var DialogDefault = function DialogDefault(_ref) {
  var children = _ref.children,
      title = _ref.title,
      openDialog = _ref.openDialog,
      closeAction = _ref.closeAction;
  var classes = useStyles();
  var fullScreen = (0, _core.useMediaQuery)(_AppTheme.default.breakpoints.down('xs'));
  return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: openDialog,
    classes: {
      paper: classes.paper
    },
    BackdropProps: {
      style: {
        backgroundColor: 'rgba(0,0,0,0.7)'
      }
    },
    fullScreen: fullScreen,
    TransitionComponent: Transition
  }, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    mt: "small",
    ml: "small",
    mr: "small"
  }, /*#__PURE__*/_react.default.createElement(_BoxFlex.default, {
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    variant: "transparentGrey",
    size: "medium",
    icon: "ic_close",
    action: function action() {
      return closeAction();
    }
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "VfGrey",
    variant: "h5",
    text: title,
    align: "center"
  })), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    className: classes.dialogChildren
  }, children));
};

DialogDefault.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node]),
  closeAction: _propTypes.default.func,
  openDialog: _propTypes.default.bool,
  title: _propTypes.default.string
};
DialogDefault.defaultProps = {
  openDialog: false
};
var _default = DialogDefault;
exports.default = _default;